import React from 'react'
import {
  Actions,
  EstimatedItem,
  HoverBlock,
  InfoLink,
  MainSection,
  TD,
  TR
} from './styles'

interface Props {
  id: number
  data: any[]
  hoverData: any[]
  actionBlock: any
}

const isNew = false
const ListItem: React.FC<Props> = ({ id, data, hoverData, actionBlock }) => (
  <TR>
    {/* <InfoLink> */}
      <MainSection>
        {data.map((item, i) => (
          <TD key={i}>{item}</TD>
        ))}
      </MainSection>
      {hoverData && hoverData.length > 0 && (
        <HoverBlock>
          {hoverData.map((hoverItem, i) => (
            <EstimatedItem key={i}>{hoverItem}</EstimatedItem>
          ))}
        </HoverBlock>
      )}
      {/* </InfoLink> */}
    {actionBlock() && <Actions>{actionBlock(id)}</Actions>}   
  </TR>
)

export default ListItem
